import Utils from '@corbieres/js/services/utils';

export default class Social {
    
    constructor()
    {
        Social.ajax_instagram();
    }
    
    static ajax_instagram()
    {
        
        let $wrapper = $( '[data-id="wpiris-instagram-wall"]' );
        
        if ( $wrapper.length > 0 ) {
            self = this;
            $.ajax( {
                        url: Theme.ajaxURL,
                        data: {
                            'action': 'social_wall',
                        },
                        type: 'POST',
                        success: function ( socialData ) {
                            $wrapper.append( socialData );
                            Utils.lazy();
                        }
                    } );
        }
    }
}
